import { DakokuApi } from '@/api/DakokuApi'
import { OshiraseApi } from '@/api/InfoApi';
import { OshiraseData } from '@/types/Oshirase';

export class OshiraseService {


  public async getOshiraseList(): Promise<OshiraseData[]> {
    const api = new OshiraseApi()
    let res = null;
    try {
      res = await api.getOshiraseList()
    } catch (e: any) {
      return []
    }

    if (!res) {
      return []
    }
    return res.list;
  }

  public async getOshiraseSummary(): Promise<OshiraseData[]> {
    const api = new OshiraseApi();
    let res = null;
    try {
      res = await api.getOshiraseSummary();
    } catch (e: any) {
      return [];
    }

    if (!res) {
      return [];
    }
    return res.list;
  }

  public async updateToRead(oshirase_id: number): Promise<void> {
    const api = new OshiraseApi()
    await api.updateToRead(oshirase_id)
  }
}
